import { useState } from "react";
import { toast } from "sonner";
import { api, err, money } from "../../lib/api";

const BASES = [1, 10, 100, 1000];
const MULTS = [1, 5, 10, 20, 50, 100];

export const ballClass = n => `ball3d b${n}`;
export const colorClass = s => ({ Green: "c-green", Red: "c-red", Violet: "c-violet", Big: "c-big", Small: "c-small" }[s] || "c-num");

export function BetSheet({ sel, game, period, balance, initialQty = 1, onClose, onPlaced }) {
  const [base, setBase] = useState(1), [qty, setQty] = useState(initialQty), [agree, setAgree] = useState(true), [busy, setBusy] = useState(false);
  const total = base * qty;
  const place = async () => {
    if (!agree) return toast.error("Please agree to the pre-sale rules");
    setBusy(true);
    try {
      await api.post("/game/bet", { game: game.game, period_id: period.period_id, selection_type: sel.type, selection: sel.value, amount: total });
      toast.success(`Bet placed · ${money(total)} on ${sel.label}`);
      onPlaced();
    } catch (e) { toast.error(err(e)); }
    setBusy(false);
  };
  const head = sel.type === "number" ? `n-head n${sel.value}` : colorClass(sel.value);
  return (
    <div className="sheet-backdrop" onClick={onClose} data-testid="bet-sheet">
      <div className="bet-sheet" onClick={e => e.stopPropagation()}>
        <div className={`sheet-head ${head}`}><b>{game.label}</b><span data-testid="bet-sheet-selection">Select&nbsp;&nbsp;{sel.label}</span></div>
        <div className="sheet-row"><span>Balance</span><div className="chip-row">{BASES.map(b => <button key={b} className={base === b ? "on" : ""} onClick={() => setBase(b)} data-testid={`bet-base-${b}`}>{b}</button>)}</div></div>
        <div className="sheet-row"><span>Quantity</span><div className="qty"><button onClick={() => setQty(Math.max(1, qty - 1))} data-testid="bet-qty-minus">−</button><input value={qty} onChange={e => setQty(Math.max(1, Number(e.target.value) || 1))} data-testid="bet-qty-input" /><button onClick={() => setQty(qty + 1)} data-testid="bet-qty-plus">+</button></div></div>
        <div className="chip-row mults">{MULTS.map(m => <button key={m} className={qty === m ? "on" : ""} onClick={() => setQty(m)} data-testid={`bet-mult-${m}`}>X{m}</button>)}</div>
        <label className="agree"><input type="checkbox" checked={agree} onChange={e => setAgree(e.target.checked)} data-testid="bet-agree-checkbox" /> I agree <em>《Pre-sale rules》</em></label>
        <p className="sheet-note">Wallet {money(balance)}</p>
        <div className="sheet-actions"><button onClick={onClose} data-testid="bet-cancel-button">Cancel</button><button className="go" onClick={place} disabled={busy} data-testid="bet-confirm-button">Total amount {money(total)}</button></div>
      </div>
    </div>
  );
}
